export default __webpack_public_path__ + "static/media/descricao.be1dcd0a.png";